
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kGADV", function(module, exports) {

var $hTKp4 = parcelRequire("hTKp4");


var $dh538 = parcelRequire("dh538");


var $baiQV = parcelRequire("baiQV");




const $520a8a2d79af9583$export$5e1aa91d6932ddaa = [
    'script',
    'link',
    'other'
];
const $520a8a2d79af9583$export$22f4983702ea2cc3 = 'mem';
const $520a8a2d79af9583$export$d85e88075ae28804 = 'disk';
const $520a8a2d79af9583$export$c46019be3f2161d7 = 'net';
function $520a8a2d79af9583$export$82deef6698791e4e(name, type, duration, size) {
    if (!$520a8a2d79af9583$export$5e1aa91d6932ddaa.includes(type) && !(type === 'other' && name.includes('.js'))) return null;
    if ((size === undefined || size === 0) && duration === 0) return $520a8a2d79af9583$export$22f4983702ea2cc3;
    if (size === 0 && duration > 0) return $520a8a2d79af9583$export$d85e88075ae28804;
    if (size === undefined) return null;
    return $520a8a2d79af9583$export$c46019be3f2161d7;
}
function $520a8a2d79af9583$export$d63396a1f85f70a0({ name: name, initiatorType: type }) {
    let category = 'other';
    const urlWithoutQuery = name.split('?')[0];
    switch(type){
        case 'script':
            category = 'js';
            break;
        case 'link':
            if (urlWithoutQuery.endsWith('.css')) category = 'css';
            if (urlWithoutQuery.endsWith('.js')) category = 'js';
            break;
        case 'img':
            category = 'image';
            break;
        case 'font':
            category = 'font';
            break;
        default:
            if (urlWithoutQuery.endsWith('.js')) category = 'js';
            else if (urlWithoutQuery.endsWith('.css')) category = 'css';
            else if (urlWithoutQuery.match(/\.(woff|woff2|ttf|otf)$/)) category = 'font';
            else if (urlWithoutQuery.match(/\.(png|jpg|jpeg|gif|svg)$/)) category = 'image';
            break;
    }
    return category;
}
function $520a8a2d79af9583$export$c67eec4e6ad72694(entry) {
    if (entry.decodedSize === 0 && entry.encodedSize === 0 && entry.requestStart === 0 && entry.responseStart === 0) return false;
    return true;
}
function $520a8a2d79af9583$export$2077e0241d6afd3c(n) {
    if (isNaN(n)) return 0;
    return Math.round(n * 10000) / 10000;
}


class $f1a4e844f2e94c0f$export$783d6618ee601ba {
    add(asset) {
        const encodedSize = asset.encodedSize || 0;
        const type = (0, $520a8a2d79af9583$export$82deef6698791e4e)(asset.name, asset.initiatorType, asset.duration, asset.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += encodedSize;
        this.sizeTotal += encodedSize;
    }
    static makePayload(summary) {
        const { size: size, bundlesCount: bundlesCount, sizeTotal: sizeTotal } = summary;
        const cachedSize = size[0, $520a8a2d79af9583$export$22f4983702ea2cc3] + size[0, $520a8a2d79af9583$export$d85e88075ae28804];
        const sizeRatio = (0, $520a8a2d79af9583$export$2077e0241d6afd3c)(cachedSize / summary.sizeTotal);
        return {
            size: sizeTotal,
            chr: sizeRatio,
            count: bundlesCount
        };
    }
    constructor(){
        this.bundles = {
            [(0, $520a8a2d79af9583$export$22f4983702ea2cc3)]: 0,
            [(0, $520a8a2d79af9583$export$d85e88075ae28804)]: 0,
            [(0, $520a8a2d79af9583$export$c46019be3f2161d7)]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [(0, $520a8a2d79af9583$export$22f4983702ea2cc3)]: 0,
            [(0, $520a8a2d79af9583$export$d85e88075ae28804)]: 0,
            [(0, $520a8a2d79af9583$export$c46019be3f2161d7)]: 0
        };
        this.sizeTotal = 0;
    }
}
class $f1a4e844f2e94c0f$export$7d0d4cfb6455ffa5 {
    get(resourceTimings, assetsConfig, SSRDoneTime) {
        try {
            if (resourceTimings === null) return null;
            resourceTimings.forEach((entry)=>{
                if (!(0, $520a8a2d79af9583$export$c67eec4e6ad72694)(entry)) return;
                const hasNanValues = (0, $dh538.fg)('platform_ufo_assets_check_for_nan') ? entry.encodedSize === undefined || entry.encodedSize === null : false;
                if (entry.encodedSize === entry.decodedSize || hasNanValues) // incorrectly reported or lack of size
                return;
                const type = (0, $520a8a2d79af9583$export$d63396a1f85f70a0)(entry);
                if (!(assetsConfig.allowedTypes || this.defaultAllowedTypes).includes(type)) return;
                if (assetsConfig.classification.all) this.all.add(entry);
                if (assetsConfig.classification.allAtlassian({
                    entry: entry
                })) this.allAtlassian.add(entry);
                if (assetsConfig.classification.preloaded({
                    entry: entry,
                    SSRDoneTime: SSRDoneTime
                })) this.preloaded.add(entry);
            });
            if (this.all.bundlesCount === 0) return null;
            const CHRData = {
                all: $f1a4e844f2e94c0f$export$783d6618ee601ba.makePayload(this.all),
                allAtlassian: $f1a4e844f2e94c0f$export$783d6618ee601ba.makePayload(this.allAtlassian),
                preloaded: $f1a4e844f2e94c0f$export$783d6618ee601ba.makePayload(this.preloaded)
            };
            return CHRData;
        } catch  {
            return null;
        }
    }
    constructor(){
        this.all = new $f1a4e844f2e94c0f$export$783d6618ee601ba();
        this.allAtlassian = new $f1a4e844f2e94c0f$export$783d6618ee601ba();
        this.preloaded = new $f1a4e844f2e94c0f$export$783d6618ee601ba();
        this.defaultAllowedTypes = [
            'js'
        ];
    }
}



var $8litl = parcelRequire("8litl");

let $82bb365c64d311e4$var$config = null;
function $82bb365c64d311e4$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $82bb365c64d311e4$var$config = bundleEvalTimingConfiguration;
}
function $82bb365c64d311e4$var$getPerformanceObject() {
    return (window ?? {}).performance;
}
function $82bb365c64d311e4$export$2eda1519e91a4386(interactionStartTime) {
    if ($82bb365c64d311e4$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $82bb365c64d311e4$var$config;
    const performance = $82bb365c64d311e4$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $8litl.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $8litl.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}



var $1haRI = parcelRequire("1haRI");


var $53d5Q = parcelRequire("53d5Q");


var $aqLdL = parcelRequire("aqLdL");


var $42omo = parcelRequire("42omo");


var $9x4nt = parcelRequire("9x4nt");


var $feexy = parcelRequire("feexy");


var $4u5NT = parcelRequire("4u5NT");

function $6741ca490e409134$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $6741ca490e409134$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const interactionId = (0, $feexy.getInteractionId)().current;
    (0, $42omo.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $4u5NT.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $6741ca490e409134$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $6741ca490e409134$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $feexy.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $4u5NT.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $6741ca490e409134$export$f02972da195a43bb(marks, timingsConfig);
        (0, $4u5NT.addCustomTiming)(interactionId, [], bm3Timings);
    }
}



var $5QpZa = parcelRequire("5QpZa");


var $jJ2Ec = parcelRequire("jJ2Ec");

const $e739d2e1bf4e00f5$var$timings = [];
function $e739d2e1bf4e00f5$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
    $e739d2e1bf4e00f5$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function $e739d2e1bf4e00f5$export$6d488733a547304() {
    const reportedTimingsObj = {};
    $e739d2e1bf4e00f5$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
        const startEntryList = performance.getEntriesByName(startMark);
        const stopEntryList = performance.getEntriesByName(stopMark);
        if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
            const startEntry = startEntryList[startEntryList.length - 1];
            const stopEntry = stopEntryList[stopEntryList.length - 1];
            const { startTime: startTime } = startEntry;
            const duration = stopEntry.startTime - startTime;
            const timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}






var $i328h = parcelRequire("i328h");








var $aanDq = parcelRequire("aanDq");


var $hS38r = parcelRequire("hS38r");

const $f909860e385c37d9$var$alwaysCacheableTypes = [
    'script',
    'link'
];
const $f909860e385c37d9$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $f909860e385c37d9$var$CACHE_NETWORK = 'network';
const $f909860e385c37d9$var$CACHE_MEMORY = 'memory';
const $f909860e385c37d9$var$CACHE_DISK = 'disk';
function $f909860e385c37d9$var$isCacheableType(url, type) {
    if ($f909860e385c37d9$var$alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
function $f909860e385c37d9$var$calculateTransferType(name, type, duration, size) {
    if (!$f909860e385c37d9$var$isCacheableType(name, type)) return $f909860e385c37d9$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $f909860e385c37d9$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $f909860e385c37d9$var$CACHE_DISK;
    if (size === undefined) return null;
    return $f909860e385c37d9$var$CACHE_NETWORK;
}
function $f909860e385c37d9$var$getWindowObject() {
    return typeof window !== 'undefined' && !!window ? window : undefined;
}
function $f909860e385c37d9$var$hasAccessToResourceSize(url, type, entry, hasTimingHeaders) {
    return !$f909860e385c37d9$var$isCacheableType(url, type) || url.includes('localhost') || !!$f909860e385c37d9$var$getWindowObject() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
}
function $f909860e385c37d9$var$getReportedInitiatorTypes(xhrEnabled) {
    const ufoConfig = (0, $53d5Q.getConfig)();
    if (!ufoConfig?.allowedResources) {
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'other',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch',
            'other'
        ];
    }
    return ufoConfig.allowedResources;
}
function $f909860e385c37d9$var$evaluateAccessToResourceTimings(_, entry) {
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
}
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
function $f909860e385c37d9$var$getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
}
function $f909860e385c37d9$var$getNetworkData(item, eventStart, hasTimingHeaders = $f909860e385c37d9$var$evaluateAccessToResourceTimings) {
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart, requestStart: requestStart, serverTime: serverTime, networkTime: networkTime, encodedSize: encodedSize, decodedSize: decodedSize } = item;
    const ttfb = (0, $8litl.roundEpsilon)(responseStart - eventStart);
    const requestStartRelative = (0, $8litl.roundEpsilon)(requestStart - eventStart);
    if (!$f909860e385c37d9$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($f909860e385c37d9$var$isCacheableType(name, initiatorType)) {
        const transferType = $f909860e385c37d9$var$calculateTransferType(name, initiatorType, duration, transferSize);
        return {
            ttfb: ttfb,
            transferType: transferType,
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: encodedSize,
            decodedSize: decodedSize,
            ...$f909860e385c37d9$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        serverTime: serverTime,
        networkTime: networkTime,
        requestStart: requestStartRelative,
        ...$f909860e385c37d9$var$getSizeObject(transferSize)
    };
}
function $f909860e385c37d9$export$9eebb59359c2e9e5(interactionStart, interactionEnd) {
    const resourceTiming = {};
    if (interactionStart === null) return resourceTiming;
    const resources = (0, $hS38r.filterResourceTimings)(interactionStart, interactionEnd);
    if (!resources?.length) return resourceTiming;
    const { xhrFilter: xhrFilter, sanitiseEndpoints: sanitiseEndpoints, mapResources: mapResources, hasTimingHeaders: hasTimingHeaders } = (0, $aanDq.getConfig)();
    const reportedInitiatorTypes = $f909860e385c37d9$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        if (initiatorType === 'other' && !name.includes('.js')) return;
        const url = $f909860e385c37d9$var$resourceTypes.includes(initiatorType) ? sanitiseEndpoints(name) : mapResources(name);
        if (!url) return;
        if (resourceTiming[url]) {
            resourceTiming[url].count = (resourceTiming[url].count || 1) + 1;
            return;
        }
        resourceTiming[url] = {
            startTime: (0, $8litl.roundEpsilon)(startTime - interactionStart),
            duration: (0, $8litl.roundEpsilon)(duration),
            workerStart: Math.max((0, $8litl.roundEpsilon)(workerStart - interactionStart), 0),
            fetchStart: Math.max((0, $8litl.roundEpsilon)(fetchStart - interactionStart), 0),
            type: initiatorType,
            ...$f909860e385c37d9$var$getNetworkData(item, interactionStart, hasTimingHeaders)
        };
    });
    return resourceTiming;
}









var $hPcrh = parcelRequire("hPcrh");


var $3AFGg = parcelRequire("3AFGg");

















var $uxMYQ = parcelRequire("uxMYQ");




function $cac08cfeb59d820e$export$2e2bcd8739ae039() {
    const data = {
        time: {
            localHour: 0,
            localDayOfWeek: 0,
            localTimezoneOffset: 0
        }
    };
    const now = new Date();
    data.time.localHour = now.getHours(); // returns the hours for this date according to local time
    data.time.localDayOfWeek = now.getDay(); // Sunday - Saturday : 0 - 6
    data.time.localTimezoneOffset = now.getTimezoneOffset(); // A number representing the difference, in minutes, between the date as evaluated in the UTC time zone and as evaluated in the local time zone.
    if (typeof navigator !== 'undefined' && navigator.userAgent != null) {
        const browser = (0, (/*@__PURE__*/$parcel$interopDefault($uxMYQ))).getParser(navigator.userAgent);
        data.browser = {
            name: browser.getBrowserName(),
            version: browser.getBrowserVersion()
        };
    }
    if (typeof navigator !== 'undefined' && navigator.hardwareConcurrency != null) {
        if (!data.device) data.device = {};
        data.device.cpus = navigator.hardwareConcurrency;
    }
    if (typeof navigator !== 'undefined' && navigator.deviceMemory != null) {
        if (!data.device) data.device = {};
        data.device.memory = navigator.deviceMemory;
    }
    // eslint-disable-next-line compat/compat
    if (typeof navigator !== 'undefined' && navigator.connection != null) data.network = {
        effectiveType: navigator.connection.effectiveType,
        rtt: navigator.connection.rtt,
        downlink: navigator.connection.downlink
    };
    if (typeof navigator !== 'undefined' && (0, $dh538.fg)('react_ufo_add_webdriver_info')) data.webdriver = Boolean(navigator.webdriver);
    return data;
}
function $cac08cfeb59d820e$export$adab82a5a24aa23e() {
    const metadata = $cac08cfeb59d820e$export$2e2bcd8739ae039();
    const legacyFormat = {};
    // Time data
    legacyFormat['event:localHour'] = metadata.time.localHour;
    legacyFormat['event:localDayOfWeek'] = metadata.time.localDayOfWeek;
    legacyFormat['event:localTimezoneOffset'] = metadata.time.localTimezoneOffset;
    // Browser data
    if (metadata.browser) {
        legacyFormat['event:browser:name'] = metadata.browser.name;
        legacyFormat['event:browser:version'] = metadata.browser.version;
    }
    // Webdriver data
    if (metadata.webdriver !== undefined) legacyFormat['event:browser:webdriver'] = metadata.webdriver;
    // Device data
    if (metadata.device) {
        if (metadata.device.cpus !== undefined) legacyFormat['event:cpus'] = metadata.device.cpus;
        if (metadata.device.memory !== undefined) legacyFormat['event:memory'] = metadata.device.memory;
    }
    // Network data
    if (metadata.network) {
        legacyFormat['event:network:effectiveType'] = metadata.network.effectiveType;
        legacyFormat['event:network:rtt'] = metadata.network.rtt;
        legacyFormat['event:network:downlink'] = metadata.network.downlink;
    }
    return legacyFormat;
}





function $9540911d8df2f8d5$export$9e0d04c44e1b23f6(interaction, experienceName) {
    return interaction.legacyMetrics?.find((metric)=>(metric.key === experienceName || metric.config.reactUFOName === experienceName) && metric.type === 'PAGE_LOAD');
}


function $595417a778a89343$export$b98bf736a4892f95(interaction, experienceName) {
    const { start: start, type: type, marks: marks } = interaction;
    const config = (0, $53d5Q.getConfig)();
    const ssrDoneTime = config?.ssr?.getSSRDoneTime?.();
    const isBM3ConfigSSRDoneAsFmp = interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp;
    const isUFOConfigSSRDoneAsFmp = interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!config?.ssr?.getSSRDoneTime;
    // Find matching legacy metric
    const matchingLegacyMetric = (0, $9540911d8df2f8d5$export$9e0d04c44e1b23f6)(interaction, experienceName);
    let fmp;
    if (type === 'page_load' || type === 'transition') {
        if (interaction.legacyMetrics && matchingLegacyMetric) {
            // Check if legacy metric has FMP
            const legacyFmp = matchingLegacyMetric.fmp; // BM3Event doesn't have fmp in types, but it might exist
            if (legacyFmp) fmp = Math.round(legacyFmp - start);
        // If no FMP in legacy metric, return undefined (don't calculate fallback)
        }
    }
    if (type === 'page_load' && fmp === undefined) {
        if (isBM3ConfigSSRDoneAsFmp || isUFOConfigSSRDoneAsFmp) {
            const foundMark = marks?.find((mark)=>mark.name === 'fmp')?.time;
            if (foundMark) fmp = Math.round(foundMark - start);
            else if (ssrDoneTime) fmp = Math.round(ssrDoneTime - start);
        // If no FMP mark and no SSR done time, fmp remains undefined
        }
    }
    return fmp;
}



var $gY4WW = parcelRequire("gY4WW");

function $d146584dbaa399b5$export$2e2bcd8739ae039(type) {
    if (type !== 'page_load') return null;
    try {
        const entries = performance.getEntriesByType('navigation');
        if (entries.length === 0) return null;
        const navigation = entries[0];
        return {
            // From https://www.w3.org/TR/resource-timing/
            redirectStart: Math.round(navigation.redirectStart),
            redirectEnd: Math.round(navigation.redirectEnd),
            fetchStart: Math.round(navigation.fetchStart),
            domainLookupStart: Math.round(navigation.domainLookupStart),
            domainLookupEnd: Math.round(navigation.domainLookupEnd),
            connectStart: Math.round(navigation.connectStart),
            connectEnd: Math.round(navigation.connectEnd),
            secureConnectionStart: Math.round(navigation.secureConnectionStart),
            requestStart: Math.round(navigation.requestStart),
            responseStart: Math.round(navigation.responseStart),
            responseEnd: Math.round(navigation.responseEnd),
            encodedBodySize: Math.round(navigation.encodedBodySize),
            decodedBodySize: Math.round(navigation.decodedBodySize),
            transferSize: Math.round(navigation.transferSize),
            // From https://www.w3.org/TR/navigation-timing-2/
            redirectCount: navigation.redirectCount,
            type: navigation.type,
            unloadEventEnd: Math.round(navigation.unloadEventEnd),
            unloadEventStart: Math.round(navigation.unloadEventStart),
            workerStart: Math.round(navigation.workerStart),
            nextHopProtocol: navigation.nextHopProtocol
        };
    } catch  {
        // Return null if there's any error accessing navigation timing
        return null;
    }
}
function $d146584dbaa399b5$export$5f36f2643451c683(type) {
    const navigationMetrics = $d146584dbaa399b5$export$2e2bcd8739ae039(type);
    if (!navigationMetrics) return {};
    return {
        'metrics:navigation': navigationMetrics
    };
}



var $3uEtK = parcelRequire("3uEtK");

async function $97c615e28287c68e$export$2e2bcd8739ae039(type, end) {
    if (type !== 'page_load') return {};
    const paint = {};
    const paintEntries = performance.getEntriesByType('paint');
    paintEntries.forEach((entry)=>{
        if (entry.name === 'first-paint') paint.fp = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') paint.fcp = Math.round(entry.startTime);
    });
    // Get LCP using PerformanceObserver
    const lcp = await new Promise((resolve)=>{
        // Check if we already have LCP entries
        const existingEntries = performance.getEntriesByType('largest-contentful-paint');
        const lastEntry = existingEntries.reduce((agg, entry)=>{
            if (entry.startTime <= end && (agg === null || agg.startTime < entry.startTime)) return entry;
            return agg;
        }, null);
        if (lastEntry) {
            resolve(lastEntry.startTime);
            return;
        }
        const observer = new PerformanceObserver((list)=>{
            const entries = Array.from(list.getEntries());
            const lastEntry = entries.reduce((agg, entry)=>{
                if (entry.startTime <= end && (agg === null || agg.startTime < entry.startTime)) return entry;
                return agg;
            }, null);
            clearTimeout(timeoutId);
            observer.disconnect();
            if (lastEntry) resolve(lastEntry.startTime);
            else resolve(null);
        });
        observer.observe({
            type: 'largest-contentful-paint',
            buffered: true
        });
        const timeoutId = setTimeout(()=>{
            observer.disconnect();
            resolve(null);
        }, 200);
    });
    if (lcp) paint.lcp = Math.round(lcp);
    return paint;
}
async function $97c615e28287c68e$export$3a01cabaa43622d(type, end) {
    const paint = await $97c615e28287c68e$export$2e2bcd8739ae039(type, end);
    const legacyFormat = {};
    if (paint.fp !== undefined) legacyFormat['metric:fp'] = paint.fp;
    if (paint.fcp !== undefined) legacyFormat['metric:fcp'] = paint.fcp;
    if (paint.lcp !== undefined) legacyFormat['metric:lcp'] = paint.lcp;
    return legacyFormat;
}



var $6Zbgf = parcelRequire("6Zbgf");




function $c6d4ab367afbe18d$export$2e2bcd8739ae039(type) {
    if (type !== 'page_load') return undefined;
    return $hPcrh.getSSRSuccess();
}



var $lD0oL = parcelRequire("lD0oL");


function $41bd2495c8585e80$export$84423319631a27a0(interaction, experienceName) {
    const { start: start, end: end, apdex: apdex } = interaction;
    // Find matching legacy metric
    const matchingLegacyMetric = (0, $9540911d8df2f8d5$export$9e0d04c44e1b23f6)(interaction, experienceName);
    // Get end times in priority order (following server-side logic)
    const apdexEndTime = apdex?.[0]?.stopTime;
    const legacyMetricsEndTime = matchingLegacyMetric?.stop;
    const ufoEndTime = end;
    let ttiEndTime;
    if (matchingLegacyMetric && legacyMetricsEndTime) // Use legacy metrics end time if we have a matching legacy metric
    ttiEndTime = legacyMetricsEndTime;
    else if (apdexEndTime) // Fall back to apdex end time if no matching legacy metrics
    ttiEndTime = apdexEndTime;
    else // Final fallback to UFO end time
    ttiEndTime = ufoEndTime;
    return ttiEndTime ? Math.round(ttiEndTime - start) : undefined;
}



var $gffgQ = parcelRequire("gffgQ");

// Local utility functions
function $5d2d1b7d4ba85d85$var$getPageVisibilityUpToTTI(interaction) {
    const { start: start } = interaction;
    const bm3EndTimeOrInteractionEndTime = interaction.apdex?.[0]?.stopTime ?? interaction.end;
    return (0, $jJ2Ec.getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
}
async function $5d2d1b7d4ba85d85$export$2b2c445402a6f795(interactionId, interaction, vcMetrics) {
    const config = (0, $53d5Q.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const { end: end, start: start, ufoName: ufoName, rate: rate, type: type, abortReason: abortReason, routeName: routeName, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName, holdInfo: holdInfo, responsiveness: responsiveness } = interaction;
    const pageVisibilityAtTTI = $5d2d1b7d4ba85d85$var$getPageVisibilityUpToTTI(interaction);
    const pageVisibilityAtTTAI = (0, $3uEtK.default)(interaction);
    const interactionStatus = (0, $gY4WW.default)(interaction);
    if (interactionStatus.originalInteractionStatus !== 'SUCCEEDED') // To reduce payload sent from the client, we don't send critical perf metrics for non-success interactions
    return null;
    const newUFOName = (0, $3AFGg.sanitizeUfoName)(ufoName);
    // Get performance metrics
    const ttai = (0, $lD0oL.default)(interaction);
    const paintMetrics = await (0, $97c615e28287c68e$export$2e2bcd8739ae039)(type, end);
    const navigationMetrics = (0, $d146584dbaa399b5$export$2e2bcd8739ae039)(type);
    const ssrSuccess = (0, $c6d4ab367afbe18d$export$2e2bcd8739ae039)(type);
    // Calculate BM3 metrics (TTI and FMP) directly
    const tti = (0, $41bd2495c8585e80$export$84423319631a27a0)(interaction, newUFOName);
    const fmp = (0, $595417a778a89343$export$b98bf736a4892f95)(interaction, newUFOName);
    // Get browser metadata (using compact nested format)
    const browserMetadata = (0, $cac08cfeb59d820e$export$2e2bcd8739ae039)();
    const lighthouseMetrics = (0, $baiQV.getLighthouseMetrics)({
        start: start,
        stop: end
    });
    // Use provided vcMetrics or calculate if not provided
    const finalVCMetrics = vcMetrics || await (0, $gffgQ.default)(interaction);
    const ttvc = finalVCMetrics['ufo:vc:rev']?.map((revision)=>{
        if (revision['metric:vc90'] === null || revision.clean !== true) return null;
        return {
            revision: revision.revision,
            vc90: revision['metric:vc90']
        };
    }).filter((revision)=>revision != null);
    // find earliest hold
    const earliestHold = holdInfo?.reduce((a, b)=>{
        if (a && a.start < b.start) return a;
        return b;
    }, null);
    // Process cohorting custom data
    const cohortingCustomData = interaction.cohortingCustomData?.size ? Object.fromEntries(interaction.cohortingCustomData) : undefined;
    const properties = {
        // Basic metadata
        'event:hostname': window.location?.hostname || 'unknown',
        'event:product': config.product,
        'event:schema': '1.0.0',
        'event:region': config.region || 'unknown',
        'event:source': {
            name: 'react-ufo/web',
            version: (0, $6Zbgf.LATEST_REACT_UFO_PAYLOAD_VERSION)
        },
        'experience:key': 'custom.ufo.critical-metrics',
        'experience:name': newUFOName,
        // Browser metadata (compact nested format)
        browser: browserMetadata.browser,
        device: browserMetadata.device,
        network: browserMetadata.network,
        time: browserMetadata.time,
        metrics: {
            fp: paintMetrics.fp,
            fcp: paintMetrics.fcp,
            lcp: paintMetrics.lcp,
            ttai: ttai,
            tti: tti,
            fmp: fmp,
            tbt: lighthouseMetrics['metric:tbt'],
            tbtObserved: lighthouseMetrics['metric:tbt:observed'],
            cls: lighthouseMetrics['metric:cls'],
            ttvc: ttvc ?? undefined,
            earliestHoldStart: earliestHold?.start ? Math.round(earliestHold.start - start) : undefined,
            inputDelay: responsiveness?.inputDelay ? Math.round(responsiveness.inputDelay) : undefined,
            inp: responsiveness?.experimentalInputToNextPaint ? Math.round(responsiveness.experimentalInputToNextPaint) : undefined,
            ...navigationMetrics && {
                navigation: navigationMetrics
            }
        },
        ...ssrSuccess !== undefined && {
            ssrSuccess: ssrSuccess
        },
        interactionId: interactionId,
        type: type,
        rate: rate,
        routeName: routeName ?? undefined,
        // Performance timings
        start: Math.round(start),
        end: Math.round(end),
        // Status and outcome
        status: interactionStatus.originalInteractionStatus,
        abortReason: abortReason,
        previousInteractionName: previousInteractionName,
        isPreviousInteractionAborted: isPreviousInteractionAborted,
        abortedByInteractionName: abortedByInteractionName,
        pageVisibilityAtTTI: pageVisibilityAtTTI ?? undefined,
        pageVisibilityAtTTAI: pageVisibilityAtTTAI,
        // Basic error count (not detailed error count)
        errorCount: interaction.errors.length,
        // Cohorting custom data
        ...Object.keys(cohortingCustomData || {}).length > 0 && {
            cohortingCustomData: cohortingCustomData
        }
    };
    const payload = {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: properties
        }
    };
    return payload;
}












function $53ac36228574081b$export$2e2bcd8739ae039(labelStack) {
    return labelStack.length === 1;
}


function $9e4f4f46b154abb4$export$2e2bcd8739ae039(labelStack) {
    for(let i = labelStack.length - 1; i >= 0; i--){
        const label = labelStack[i];
        if ('segmentId' in label) return label.segmentId;
    }
    return undefined;
}







function $73cdfc1b26d5274c$export$2e2bcd8739ae039(errors, segmentId) {
    return errors.some((error)=>{
        if (!error.labelStack) return false;
        const errorSegmentId = (0, $9e4f4f46b154abb4$export$2e2bcd8739ae039)(error.labelStack);
        return errorSegmentId === segmentId;
    });
}


function $47f7691b7083ef57$export$2e2bcd8739ae039(labelStack, segmentId) {
    return labelStack.some((label)=>{
        return 'segmentId' in label && label.segmentId === segmentId;
    });
}


function $e30b31050b28ac05$export$2e2bcd8739ae039(interaction, segment) {
    const segmentId = (0, $9e4f4f46b154abb4$export$2e2bcd8739ae039)(segment.labelStack);
    // Get the root interaction status info
    const rootInteractionStatus = (0, $gY4WW.default)(interaction);
    const rootStatus = rootInteractionStatus.originalInteractionStatus;
    const rootAbortReason = interaction.abortReason;
    const isInteractionsAbortedByNewInteraction = rootStatus === 'ABORTED' && rootAbortReason === 'new_interaction';
    const isInteractionsAbortedByTransition = rootStatus === 'ABORTED' && rootAbortReason === 'transition';
    let status = 'SUCCEEDED';
    let abortReason;
    // Check if this specific segment has failed
    if (segmentId && (0, $73cdfc1b26d5274c$export$2e2bcd8739ae039)(interaction.errors, segmentId)) status = 'FAILED';
    else if (isInteractionsAbortedByNewInteraction) {
        status = 'ABORTED';
        abortReason = 'new_interaction';
    } else if (isInteractionsAbortedByTransition) {
        status = 'ABORTED';
        abortReason = 'transition';
    } else if (segmentId) {
        // Check for active holds that are under this segment
        for (const activeHold of interaction.holdActive.values())if ((0, $47f7691b7083ef57$export$2e2bcd8739ae039)(activeHold.labelStack, segmentId)) {
            status = 'ABORTED';
            abortReason = 'timeout';
            break;
        }
    }
    return {
        status: status,
        abortReason: abortReason
    };
}


async function $4a534e12fd2a299e$export$267f7174399ab737(interactionId, interaction) {
    const config = (0, $53d5Q.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    // Get browser metadata (using compact nested format)
    const browserMetadata = (0, $cac08cfeb59d820e$export$2e2bcd8739ae039)();
    // Process cohorting custom data
    const cohortingCustomData = interaction.cohortingCustomData?.size ? Object.fromEntries(interaction.cohortingCustomData) : undefined;
    const pageVisibilityAtTTAI = (0, $3uEtK.default)(interaction);
    const { knownSegments: knownSegments, reactProfilerTimings: reactProfilerTimings, rate: rate, routeName: routeName, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName } = interaction;
    // Group segments by name and select the first segment for each name
    const segmentsByName = new Map();
    for (const segment of knownSegments){
        const segmentId = (0, $9e4f4f46b154abb4$export$2e2bcd8739ae039)(segment.labelStack);
        // skip if no segmentId
        if (!segmentId) continue;
        const name = segment.labelStack[segment.labelStack.length - 1].name;
        const isRootSegment = (0, $53ac36228574081b$export$2e2bcd8739ae039)(segment.labelStack);
        const segmentProfilerTimings = reactProfilerTimings.filter((timing)=>{
            const timingSegmentId = (0, $9e4f4f46b154abb4$export$2e2bcd8739ae039)(timing.labelStack);
            // check if labelStack matches exactly
            return timingSegmentId === segmentId;
        }).sort((a, b)=>{
            return a.startTime - b.startTime;
        });
        const firstMountTiming = segmentProfilerTimings.find((timing)=>{
            return timing.type === 'mount';
        });
        if (!firstMountTiming) continue;
        const firstMountTime = isRootSegment ? interaction.start : firstMountTiming.startTime;
        // Check if we already have a segment with this name
        const existingEntry = segmentsByName.get(name);
        if (!existingEntry || firstMountTime < existingEntry.firstMountTime) // Either first time seeing this name, or this segment mounted earlier
        segmentsByName.set(name, {
            segment: segment,
            firstMountTime: firstMountTime
        });
    }
    // Create payloads only for the selected segments (first one per name)
    const payloads = [];
    for (const { segment: segment } of segmentsByName.values()){
        const segmentId = (0, $9e4f4f46b154abb4$export$2e2bcd8739ae039)(segment.labelStack);
        const name = segment.labelStack[segment.labelStack.length - 1].name;
        const isRootSegment = (0, $53ac36228574081b$export$2e2bcd8739ae039)(segment.labelStack);
        const segmentProfilerTimings = reactProfilerTimings.filter((timing)=>{
            const timingSegmentId = (0, $9e4f4f46b154abb4$export$2e2bcd8739ae039)(timing.labelStack);
            // check if labelStack matches exactly
            return timingSegmentId === segmentId;
        }).sort((a, b)=>{
            return a.startTime - b.startTime;
        });
        const firstMountTiming = segmentProfilerTimings.find((timing)=>{
            return timing.type === 'mount';
        });
        // We already checked this exists in the grouping phase
        if (!firstMountTiming) continue;
        const lastTiming = segmentProfilerTimings[segmentProfilerTimings.length - 1];
        const startTime = isRootSegment ? interaction.start : firstMountTiming.startTime;
        const endTime = lastTiming.commitTime;
        const ttai = Math.round(endTime - startTime);
        const { status: status, abortReason: segmentAbortReason } = (0, $e30b31050b28ac05$export$2e2bcd8739ae039)(interaction, segment);
        if (status !== 'SUCCEEDED') continue;
        const properties = {
            // Basic metadata
            'event:hostname': window.location?.hostname || 'unknown',
            'event:product': config.product,
            'event:schema': '1.0.0',
            'event:region': config.region || 'unknown',
            'event:source': {
                name: 'react-ufo/web',
                version: (0, $6Zbgf.LATEST_REACT_UFO_PAYLOAD_VERSION)
            },
            'experience:key': 'custom.ufo.critical-metrics',
            'experience:name': name,
            // Browser metadata (compact nested format)
            browser: browserMetadata.browser,
            device: browserMetadata.device,
            network: browserMetadata.network,
            time: browserMetadata.time,
            metrics: {
                ttai: ttai,
                tti: ttai
            },
            interactionId: interactionId,
            type: 'page_segment_load',
            rate: rate,
            routeName: routeName ?? undefined,
            // Performance timings
            start: Math.round(startTime),
            end: Math.round(endTime),
            status: // Status and outcome
            status,
            abortReason: segmentAbortReason,
            previousInteractionName: previousInteractionName,
            isPreviousInteractionAborted: isPreviousInteractionAborted,
            abortedByInteractionName: abortedByInteractionName,
            pageVisibilityAtTTAI: pageVisibilityAtTTAI,
            // Basic error count (not detailed error count)
            errorCount: interaction.errors.length,
            // Cohorting custom data
            ...Object.keys(cohortingCustomData || {}).length > 0 && {
                cohortingCustomData: cohortingCustomData
            }
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            eventType: 'operational',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: properties
            }
        };
        payloads.push(payload);
    }
    return payloads;
}


async function $68a44b660af02473$export$dbc5b5c3cadc26f7(interactionId, interaction, vcMetrics) {
    const [rootPayload, segmentPayloads] = await Promise.all([
        (0, $5d2d1b7d4ba85d85$export$2b2c445402a6f795)(interactionId, interaction, vcMetrics),
        (0, $dh538.fg)('platform_ufo_segment_critical_metrics') ? (0, $4a534e12fd2a299e$export$267f7174399ab737)(interactionId, interaction) : []
    ]);
    return [
        rootPayload,
        ...segmentPayloads
    ].filter((v)=>v != null);
}


const $f327de5adcc2341e$export$aae9bceb5496a29f = (start, measures)=>{
    try {
        measures.sort((a, b)=>b.revision.localeCompare(a.revision)).slice(0, 2).forEach((entry)=>{
            if (entry.vcDetails?.['90']?.t !== undefined) performance.mark(`VC90 (${entry.revision})`, {
                startTime: start + entry.vcDetails?.['90']?.t,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        });
        measures.forEach((entry)=>{
            if (!entry || !entry.vcDetails) return;
            const VCParts = Object.keys(entry.vcDetails);
            performance.measure(`VC90 (${entry.revision})`, {
                start: start,
                duration: entry.vcDetails?.['90']?.t,
                detail: {
                    devtools: {
                        track: `main metrics`,
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'tertiary'
                    }
                }
            });
            VCParts.forEach((key)=>{
                const duration = entry.vcDetails?.[key].t;
                if (typeof duration !== 'number') return;
                performance.measure(`VC${key}`, {
                    start: start,
                    duration: duration,
                    detail: {
                        devtools: {
                            track: `VC ${entry.revision}`,
                            trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                            color: key === '90' ? 'tertiary' : 'primary-light'
                        }
                    }
                });
            });
        });
    } catch  {}
};





async function $c7d37add8d34b6ec$export$2e2bcd8739ae039() {
    if (!(0, $dh538.fg)('react_ufo_battery_info')) return {};
    if (typeof navigator === 'undefined') return {};
    try {
        // Try modern getBattery() API first
        if ('getBattery' in navigator) {
            const battery = await navigator.getBattery();
            if (battery && typeof battery.level === 'number' && typeof battery.charging === 'boolean') return {
                level: Math.round(battery.level * 100) / 100,
                charging: battery.charging
            };
        }
    } catch  {
    // Silently ignore errors - battery info is optional
    }
    return {};
}
async function $c7d37add8d34b6ec$export$42f40d22522b34d7() {
    const battery = await $c7d37add8d34b6ec$export$2e2bcd8739ae039();
    const legacyFormat = {};
    if (battery.level !== undefined) legacyFormat['event:battery:level'] = battery.level;
    if (battery.charging !== undefined) legacyFormat['event:battery:charging'] = battery.charging;
    return legacyFormat;
}







var $2G1lj = parcelRequire("2G1lj");







var $2j9Nh = parcelRequire("2j9Nh");





var $657nk = parcelRequire("657nk");









var $6cRSt = parcelRequire("6cRSt");


var $1wWrF = parcelRequire("1wWrF");


var $eGSg6 = parcelRequire("eGSg6");


var $g4VPN = parcelRequire("g4VPN");


var $9uif7 = parcelRequire("9uif7");


var $42oBg = parcelRequire("42oBg");


var $kzLre = parcelRequire("kzLre");


var $15prs = parcelRequire("15prs");

const $1ce9cf3f9c71f474$var$MAX_PAYLOAD_SIZE = 230;
function $1ce9cf3f9c71f474$var$getUfoNameOverride(interaction) {
    const { ufoName: ufoName, apdex: apdex } = interaction;
    try {
        const ufoNameOverrides = (0, $53d5Q.getUfoNameOverrides)();
        if (ufoNameOverrides != null) {
            const metricKey = apdex.length > 0 ? apdex[0].key : '';
            if (ufoNameOverrides[ufoName][metricKey]) return ufoNameOverrides[ufoName][metricKey];
        }
        return ufoName;
    } catch  {
        return ufoName;
    }
}
function $1ce9cf3f9c71f474$var$getEarliestLegacyStopTime(interaction, labelStack) {
    let earliestLegacyStopTime = null;
    interaction.apdex.forEach((a)=>{
        if (!a?.stopTime) return;
        if (!(0, $3AFGg.labelStackStartWith)(a.labelStack ?? [], labelStack)) return;
        if (a.stopTime > interaction.start && (earliestLegacyStopTime ?? a.stopTime) >= a.stopTime) earliestLegacyStopTime = a.stopTime;
    });
    return earliestLegacyStopTime;
}
function $1ce9cf3f9c71f474$var$getBm3EndTimeOrFallbackValue(interaction, labelStack = [], fallbackValue = interaction.end) {
    if (interaction.type === 'press') return fallbackValue;
    return $1ce9cf3f9c71f474$var$getEarliestLegacyStopTime(interaction, labelStack) ?? fallbackValue;
}
function $1ce9cf3f9c71f474$var$getPageVisibilityUpToTTI(interaction) {
    const { start: start } = interaction;
    const bm3EndTimeOrInteractionEndTime = $1ce9cf3f9c71f474$var$getBm3EndTimeOrFallbackValue(interaction);
    return (0, $jJ2Ec.getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
}
function $1ce9cf3f9c71f474$var$getMoreAccuratePageVisibilityUpToTTI(interaction) {
    const old = $1ce9cf3f9c71f474$var$getPageVisibilityUpToTTI(interaction);
    const tti = $1ce9cf3f9c71f474$var$getEarliestLegacyStopTime(interaction, []);
    if (!tti) return old;
    const buffered = (0, $6cRSt.getVisibilityStateFromPerformance)(tti);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}
function $1ce9cf3f9c71f474$var$getResourceTimings(start, end) {
    return $f909860e385c37d9$export$9eebb59359c2e9e5(start, end) ?? undefined;
}
function $1ce9cf3f9c71f474$var$getBundleEvalTimings(start) {
    return $82bb365c64d311e4$export$2eda1519e91a4386(start);
}
function $1ce9cf3f9c71f474$var$getSSRPhaseSuccess(type) {
    return type === 'page_load' ? $hPcrh.getSSRPhaseSuccess() : undefined;
}
function $1ce9cf3f9c71f474$var$getSSRFeatureFlags(type) {
    return type === 'page_load' ? $hPcrh.getSSRFeatureFlags() : undefined;
}
function $1ce9cf3f9c71f474$var$getPPSMetrics(interaction) {
    const { start: start, end: end } = interaction;
    const config = (0, $53d5Q.getConfig)();
    const interactionStatus = (0, $gY4WW.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $3uEtK.default)(interaction);
    const tti = interaction.apdex?.[0]?.stopTime;
    const ttai = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
    const PPSMetricsAtTTI = tti !== undefined ? (0, $baiQV.getLighthouseMetrics)({
        start: start,
        stop: tti
    }) : null;
    const PPSMetricsAtTTAI = ttai !== undefined ? (0, $baiQV.getLighthouseMetrics)({
        start: start,
        stop: interaction.end
    }) : null;
    if ((0, $dh538.fg)('platform_ufo_remove_deprecated_config_fields')) {
        if (PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
    } else {
        if (config?.shouldCalculateLighthouseMetricsFromTTAI && PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
        if (PPSMetricsAtTTI !== null) return {
            ...PPSMetricsAtTTI,
            'metrics@ttai': PPSMetricsAtTTAI
        };
    }
    return {};
}
function $1ce9cf3f9c71f474$var$getSSRProperties(type) {
    const ssrPhases = $1ce9cf3f9c71f474$var$getSSRPhaseSuccess(type);
    return {
        'ssr:success': ssrPhases?.done != null ? ssrPhases.done : (0, $c6d4ab367afbe18d$export$2e2bcd8739ae039)(type),
        'ssr:featureFlags': $1ce9cf3f9c71f474$var$getSSRFeatureFlags(type),
        ...ssrPhases?.earlyFlush != null ? {
            'ssr:earlyflush:success': ssrPhases.earlyFlush
        } : null,
        ...ssrPhases?.prefetch != null ? {
            'ssr:prefetch:success': ssrPhases.prefetch
        } : null
    };
}
function $1ce9cf3f9c71f474$var$getAssetsMetrics(interaction, SSRDoneTime) {
    try {
        const config = (0, $53d5Q.getConfig)();
        const { type: type } = interaction;
        const allowedTypes = [
            'page_load'
        ];
        const assetsConfig = config?.assetsConfig;
        if (!allowedTypes.includes(type) || !assetsConfig) // Skip if: type not allowed or assetsClassification isn't configured
        return {};
        const reporter = new (0, $f1a4e844f2e94c0f$export$7d0d4cfb6455ffa5)();
        const resourceTimings = (0, $hS38r.filterResourceTimings)(interaction.start, interaction.end);
        const assets = reporter.get(resourceTimings, assetsConfig, SSRDoneTime);
        if (assets) // Only add assets in case it exists
        return {
            'event:assets': assets
        };
        return {};
    } catch  {
        // Skip CHR in case of error
        return {};
    }
}
function $1ce9cf3f9c71f474$var$getTracingContextData(interaction) {
    const { trace: trace, start: start } = interaction;
    let tracingContextData = {};
    if (trace) tracingContextData = {
        'ufo:tracingContext': {
            'X-B3-TraceId': trace.traceId,
            'X-B3-SpanId': trace.spanId,
            // eslint-disable-next-line compat/compat
            browserTimeOrigin: +(performance.timeOrigin + start).toFixed(2)
        }
    };
    return tracingContextData;
}
function $1ce9cf3f9c71f474$var$optimizeCustomData(interaction) {
    const { customData: customData, cohortingCustomData: cohortingCustomData, legacyMetrics: legacyMetrics } = interaction;
    const customDataMap = customData.reduce((result, { labelStack: labelStack, data: data })=>{
        const label = (0, $3AFGg.stringifyLabelStackFully)(labelStack);
        const value = result.get(label)?.data ?? {};
        result.set(label, {
            labelStack: (0, $3AFGg.optimizeLabelStack)(labelStack, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            data: Object.assign(value, data)
        });
        return result;
    }, new Map());
    // Merge cohorting custom data into the same map
    if (cohortingCustomData && cohortingCustomData.size > 0) {
        const label = (0, $3AFGg.stringifyLabelStackFully)(interaction.labelStack ?? []);
        const value = customDataMap.get(label)?.data ?? {};
        customDataMap.set(label, {
            labelStack: (0, $3AFGg.optimizeLabelStack)(interaction.labelStack ?? [], (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            data: Object.assign(value, Object.fromEntries(cohortingCustomData))
        });
    }
    if (legacyMetrics) {
        const legacyMetricsFiltered = legacyMetrics.filter((item)=>item.type === 'PAGE_LOAD').reduce((result, currentValue)=>{
            for (const [key, value] of Object.entries(currentValue.custom || {})){
                const label = (0, $3AFGg.stringifyLabelStackFully)([]);
                const labelValue = result.get(label)?.data ?? {};
                result.set(label, {
                    labelStack: (0, $3AFGg.optimizeLabelStack)([], (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    data: Object.assign(labelValue, {
                        [key]: value
                    })
                });
            }
            return result;
        }, new Map());
        return [
            ...customDataMap.values(),
            ...legacyMetricsFiltered.values()
        ];
    }
    return [
        ...customDataMap.values()
    ];
}
function $1ce9cf3f9c71f474$var$optimizeRedirects(redirects, interactionStart) {
    let lastRedirectTime = interactionStart;
    const updatedRedirects = redirects.sort((a, b)=>a.time - b.time).reduce((result, redirect)=>{
        const { fromInteractionName: fromInteractionName, time: time } = redirect;
        if (lastRedirectTime >= interactionStart) result.push({
            labelStack: [
                {
                    n: fromInteractionName
                }
            ],
            startTime: Math.round(lastRedirectTime),
            endTime: Math.round(time)
        });
        lastRedirectTime = time;
        return result;
    }, []);
    return updatedRedirects;
}
function $1ce9cf3f9c71f474$var$objectToArray(obj = {}) {
    return Object.keys(obj).reduce((result, key)=>{
        result.push({
            label: key,
            data: obj[key]
        });
        return result;
    }, []);
}
function $1ce9cf3f9c71f474$var$getBM3SubmetricsTimings(submetrics) {
    if (!submetrics) return null;
    const submetricsTimings = submetrics.filter((item)=>{
        return typeof item.stop === 'number' && !!item.key && typeof item.start === 'number';
    }).map((item)=>{
        let childSubmetrics;
        const newKey = `include/${item.key}`;
        if (item.submetrics) childSubmetrics = $1ce9cf3f9c71f474$var$getBM3SubmetricsTimings(item.submetrics);
        return {
            [newKey]: {
                endTime: item.stop - item.start,
                startTime: item.start
            },
            ...childSubmetrics ? childSubmetrics : {}
        };
    });
    return submetricsTimings;
}
function $1ce9cf3f9c71f474$var$getBm3TrackerTimings(interaction) {
    const interactionLegacyMetrics = interaction.legacyMetrics;
    if (!interactionLegacyMetrics) return {};
    const legacyMetrics = interactionLegacyMetrics.map((item)=>{
        return {
            key: item.key,
            startTime: item.start,
            stopTime: item.stop,
            type: item.config?.type,
            reactUFOName: item.config?.reactUFOName,
            fmp: item.marks?.['fmp'] || item.stop,
            source: 'bm3',
            timings: (0, $6741ca490e409134$export$f02972da195a43bb)(item.marks, item.config.timings),
            submetrics: $1ce9cf3f9c71f474$var$getBM3SubmetricsTimings(item.submetrics),
            pageVisibleState: item.pageVisibleState
        };
    }).filter((item)=>!!item.type);
    return {
        legacyMetrics: legacyMetrics
    };
}
function $1ce9cf3f9c71f474$var$getStylesheetMetrics() {
    try {
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return {};
        const stylesheets = Array.from(doc.styleSheets);
        const stylesheetCount = stylesheets.length;
        const cssrules = Array.from(doc.styleSheets).reduce((acc, item)=>{
            // Other domain stylesheets throw a SecurityError
            try {
                return acc + item.cssRules.length;
            } catch  {
                return acc;
            }
        }, 0);
        const styleElements = doc.querySelectorAll('style').length;
        const styleProps = doc.querySelectorAll('[style]');
        const styleDeclarations = Array.from(doc.querySelectorAll('[style]')).reduce((acc, item)=>{
            try {
                if ('style' in item) return acc + item.style.length;
                else return acc;
            } catch  {
                return acc;
            }
        }, 0);
        return {
            'ufo:stylesheets': stylesheetCount,
            'ufo:styleElements': styleElements,
            'ufo:styleProps': styleProps.length,
            'ufo:styleDeclarations': styleDeclarations,
            'ufo:cssrules': cssrules
        };
    } catch  {
        return {};
    }
}
let $1ce9cf3f9c71f474$var$regularTTAI;
let $1ce9cf3f9c71f474$var$expTTAI;
function $1ce9cf3f9c71f474$var$getErrorCounts(interaction) {
    return {
        'ufo:errors:globalCount': (0, $5QpZa.getGlobalErrorCount)(),
        'ufo:errors:count': interaction.errors.length
    };
}
async function $1ce9cf3f9c71f474$var$createInteractionMetricsPayload(interaction, interactionId, experimental, criticalPayloadCount, vcMetrics) {
    const interactionPayloadStart = performance.now();
    const config = (0, $53d5Q.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const { end: end, start: start, ufoName: ufoName, knownSegments: knownSegments, rate: rate, type: type, abortReason: abortReason, routeName: routeName, featureFlags: featureFlags, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName, responsiveness: responsiveness, unknownElementName: unknownElementName, unknownElementHierarchy: unknownElementHierarchy, hydration: hydration } = interaction;
    const pageVisibilityAtTTI = $1ce9cf3f9c71f474$var$getPageVisibilityUpToTTI(interaction);
    const pageVisibilityAtTTAI = (0, $3uEtK.default)(interaction);
    const segments = !(0, $dh538.fg)('platform_ufo_remove_deprecated_config_fields') && config.killswitchNestedSegments ? [] : knownSegments;
    const segmentTree = (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? (0, $3AFGg.buildSegmentTree)(segments.map((segment)=>segment.labelStack)) : {};
    const isDetailedPayload = pageVisibilityAtTTAI === 'visible';
    const isPageLoadEvent = type === 'page_load' || type === 'transition';
    const isPageLoad = type === 'page_load';
    const calculatePageVisibilityFromTheStartOfPageLoad = (config.enableBetterPageVisibilityApi ?? (0, $dh538.fg)('platform_enable_better_page_visibility')) && isPageLoadEvent;
    const moreAccuratePageVisibilityAtTTI = calculatePageVisibilityFromTheStartOfPageLoad ? $1ce9cf3f9c71f474$var$getMoreAccuratePageVisibilityUpToTTI(interaction) : null;
    const moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? (0, $2G1lj.getMoreAccuratePageVisibilityUpToTTAI)(interaction) : null;
    const labelStack = interaction.labelStack ? {
        labelStack: (0, $3AFGg.optimizeLabelStack)(interaction.labelStack, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type))
    } : {};
    // Page Load
    const getInitialPageLoadSSRMetrics = ()=>{
        if (!isPageLoad) return {};
        const config = (0, $53d5Q.getConfig)();
        const SSRDoneTimeValue = (0, $657nk.default)(config);
        const SSRDoneTime = SSRDoneTimeValue !== undefined ? {
            SSRDoneTime: Math.round(SSRDoneTimeValue)
        } : {};
        const isBM3ConfigSSRDoneAsFmp = interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp;
        const isUFOConfigSSRDoneAsFmp = interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!config?.ssr?.getSSRDoneTime;
        if (!experimental && (isBM3ConfigSSRDoneAsFmp || isUFOConfigSSRDoneAsFmp) && SSRDoneTimeValue !== undefined) try {
            performance.mark(`FMP`, {
                startTime: SSRDoneTimeValue,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {}
        return {
            ...SSRDoneTime,
            isBM3ConfigSSRDoneAsFmp: isBM3ConfigSSRDoneAsFmp,
            isUFOConfigSSRDoneAsFmp: isUFOConfigSSRDoneAsFmp
        };
    };
    const pageLoadInteractionMetrics = getInitialPageLoadSSRMetrics();
    // Detailed payload. Page visibility = visible
    const getDetailedInteractionMetrics = (resourceTimings)=>{
        if (experimental || window.__UFO_COMPACT_PAYLOAD__ || !isDetailedPayload) return {};
        const spans = [
            ...interaction.spans,
            ...(0, $4u5NT.interactionSpans)
        ];
        (0, $4u5NT.interactionSpans).length = 0;
        const shouldInclude3pHolds = (0, $53d5Q.shouldUseRawDataThirdPartyBehavior)(ufoName, type);
        const basePayload = {
            errors: interaction.errors.map(({ labelStack: labelStack, ...others })=>({
                    ...others,
                    labelStack: labelStack && (0, $3AFGg.optimizeLabelStack)(labelStack, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type))
                })),
            holdActive: [
                ...interaction.holdActive.values()
            ],
            redirects: $1ce9cf3f9c71f474$var$optimizeRedirects(interaction.redirects, start),
            holdInfo: (0, $g4VPN.optimizeHoldInfo)(experimental ? interaction.holdExpInfo : interaction.holdInfo, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            spans: (0, $15prs.optimizeSpans)(spans, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            requestInfo: (0, $kzLre.optimizeRequestInfo)(interaction.requestInfo, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            customTimings: (0, $eGSg6.optimizeCustomTimings)(interaction.customTimings, start),
            bundleEvalTimings: $1ce9cf3f9c71f474$var$objectToArray($1ce9cf3f9c71f474$var$getBundleEvalTimings(start)),
            resourceTimings: $1ce9cf3f9c71f474$var$objectToArray(resourceTimings)
        };
        // Include third-party holds when feature flag is active
        if (shouldInclude3pHolds) return {
            ...basePayload,
            hold3pActive: interaction.hold3pActive ? [
                ...interaction.hold3pActive.values()
            ] : [],
            hold3pInfo: (0, $g4VPN.optimizeHoldInfo)(interaction.hold3pInfo ?? [], start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type))
        };
        return basePayload;
    };
    // Page load & detailed payload
    const getPageLoadDetailedInteractionMetrics = ()=>{
        if (!isPageLoad || !isDetailedPayload) return {};
        const initialPageLoadExtraTimings = $1ce9cf3f9c71f474$var$objectToArray($e739d2e1bf4e00f5$export$6d488733a547304());
        const config = (0, $53d5Q.getConfig)();
        const defaultSSRTimings = $1ce9cf3f9c71f474$var$objectToArray($hPcrh.getSSRTimings());
        const ssrTimingsFromConfig = config?.ssr?.getSSRTimings?.();
        return {
            initialPageLoadExtraTimings: initialPageLoadExtraTimings,
            SSRTimings: ssrTimingsFromConfig ? [
                ...ssrTimingsFromConfig,
                ...defaultSSRTimings
            ] : defaultSSRTimings
        };
    };
    if (experimental) $1ce9cf3f9c71f474$var$expTTAI = (0, $lD0oL.default)(interaction);
    else $1ce9cf3f9c71f474$var$regularTTAI = (0, $lD0oL.default)(interaction);
    const newUFOName = (0, $3AFGg.sanitizeUfoName)(ufoName);
    const resourceTimings = $1ce9cf3f9c71f474$var$getResourceTimings(start, end);
    const [finalVCMetrics, experimentalMetrics, paintMetrics, batteryInfo] = await Promise.all([
        vcMetrics || await (0, $gffgQ.default)(interaction),
        experimental ? (0, $aqLdL.getExperimentalVCMetrics)(interaction) : Promise.resolve(undefined),
        (0, $97c615e28287c68e$export$3a01cabaa43622d)(type, end),
        (0, $c7d37add8d34b6ec$export$42f40d22522b34d7)()
    ]);
    if (!experimental) (0, $f327de5adcc2341e$export$aae9bceb5496a29f)(interaction.start, [
        ...finalVCMetrics?.['ufo:vc:rev'] || []
    ]);
    const getReactHydrationStats = ()=>{
        if (!hydration) return {};
        return {
            hydration: hydration
        };
    };
    const payload = {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:population': config.population,
                'event:schema': '1.0.0',
                'event:sizeInKb': 0,
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)
                },
                'event:region': config.region || 'unknown',
                'experience:key': experimental ? 'custom.experimental-interaction-metrics' : 'custom.interaction-metrics',
                'experience:name': newUFOName,
                // Include CPU usage monitoring data
                'event:cpu:usage': (0, $i328h.createPressureStateReport)(interaction.start, interaction.end),
                'event:memory:usage': (0, $i328h.createMemoryStateReport)(interaction.start, interaction.end),
                ...criticalPayloadCount !== undefined ? {
                    'ufo:multipayload': true,
                    'ufo:criticalPayloadCount': criticalPayloadCount
                } : {},
                // root
                ...(0, $cac08cfeb59d820e$export$adab82a5a24aa23e)(),
                ...batteryInfo,
                ...$1ce9cf3f9c71f474$var$getSSRProperties(type),
                ...$1ce9cf3f9c71f474$var$getAssetsMetrics(interaction, pageLoadInteractionMetrics?.SSRDoneTime),
                ...$1ce9cf3f9c71f474$var$getPPSMetrics(interaction),
                ...paintMetrics,
                ...(0, $d146584dbaa399b5$export$5f36f2643451c683)(type),
                ...finalVCMetrics,
                ...experimentalMetrics,
                ...config.additionalPayloadData?.(interaction),
                ...$1ce9cf3f9c71f474$var$getTracingContextData(interaction),
                ...$1ce9cf3f9c71f474$var$getStylesheetMetrics(),
                ...$1ce9cf3f9c71f474$var$getErrorCounts(interaction),
                ...getReactHydrationStats(),
                interactionMetrics: {
                    namePrefix: config.namePrefix || '',
                    segmentPrefix: config.segmentPrefix || '',
                    interactionId: interactionId,
                    pageVisibilityAtTTI: pageVisibilityAtTTI,
                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                    experimental__pageVisibilityAtTTI: moreAccuratePageVisibilityAtTTI,
                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                    rate: // raw interaction metrics
                    rate,
                    routeName: routeName,
                    type: type,
                    abortReason: abortReason,
                    featureFlags: featureFlags,
                    previousInteractionName: previousInteractionName,
                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                    abortedByInteractionName: abortedByInteractionName,
                    // performance
                    apdex: (0, $1wWrF.optimizeApdex)(interaction.apdex, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    end: Math.round(end),
                    ...interaction.end3p ? {
                        end3p: Math.round(interaction.end3p)
                    } : {},
                    start: Math.round(start),
                    segments: (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? segmentTree : (0, $3AFGg.getOldSegmentsLabelStack)(segments, interaction.type),
                    marks: (0, $9uif7.optimizeMarks)(interaction.marks, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    customData: $1ce9cf3f9c71f474$var$optimizeCustomData(interaction),
                    reactProfilerTimings: (0, $42oBg.optimizeReactProfilerTimings)(interaction.reactProfilerTimings, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    minorInteractions: interaction.minorInteractions,
                    ...responsiveness ? {
                        responsiveness: responsiveness
                    } : {},
                    ...labelStack,
                    ...pageLoadInteractionMetrics,
                    ...getDetailedInteractionMetrics(resourceTimings),
                    ...getPageLoadDetailedInteractionMetrics(),
                    ...$1ce9cf3f9c71f474$var$getBm3TrackerTimings(interaction),
                    'metric:ttai': experimental ? $1ce9cf3f9c71f474$var$regularTTAI || $1ce9cf3f9c71f474$var$expTTAI : undefined,
                    'metric:experimental:ttai': $1ce9cf3f9c71f474$var$expTTAI,
                    ...unknownElementName ? {
                        unknownElementName: unknownElementName
                    } : {},
                    ...unknownElementHierarchy ? {
                        unknownElementHierarchy: unknownElementHierarchy
                    } : {}
                },
                'ufo:payloadTime': (0, $8litl.roundEpsilon)(performance.now() - interactionPayloadStart)
            }
        }
    };
    if (experimental) {
        $1ce9cf3f9c71f474$var$regularTTAI = undefined;
        $1ce9cf3f9c71f474$var$expTTAI = undefined;
    }
    if ((0, $dh538.fg)('platform_ufo_enable_vc_raw_data')) {
        const size = (0, $2j9Nh.default)(payload.attributes.properties);
        const vcRev = payload.attributes.properties['ufo:vc:rev'];
        const rawData = vcRev.find((item)=>item.revision === 'raw-handler');
        if (rawData) {
            const rawDataSize = (0, $2j9Nh.default)(rawData);
            payload.attributes.properties['ufo:vc:raw:size'] = rawDataSize;
            if (size > $1ce9cf3f9c71f474$var$MAX_PAYLOAD_SIZE && Array.isArray(vcRev) && vcRev.length > 0) {
                payload.attributes.properties['ufo:vc:rev'] = vcRev.filter((item)=>item.revision !== 'raw-handler');
                payload.attributes.properties['ufo:vc:raw:removed'] = true;
            }
        }
        payload.attributes.properties['event:sizeInKb'] = (0, $2j9Nh.default)(payload.attributes.properties);
    } else payload.attributes.properties['event:sizeInKb'] = (0, $2j9Nh.default)(payload.attributes.properties);
    if ((0, $dh538.fg)('platform_ufo_enable_trimmed_payload')) {
        // in order of importance, first one being least important
        // we can add more fields as necessary
        const interactionMetricsFieldsToTrim = [
            'requestInfo',
            'featureFlags',
            'resourceTimings'
        ];
        const properties = payload.attributes.properties;
        const interactionMetrics = properties.interactionMetrics;
        if (interactionMetrics) for (const field of interactionMetricsFieldsToTrim){
            if ((0, $2j9Nh.default)(properties) <= $1ce9cf3f9c71f474$var$MAX_PAYLOAD_SIZE) continue;
            interactionMetrics[field] = undefined;
            properties['event:isTrimmed'] = true;
            let trimmedFields = properties['event:trimmedFields'];
            if (!Array.isArray(trimmedFields)) trimmedFields = [];
            trimmedFields.push(`interactionMetrics.${field}`);
            properties['event:trimmedFields'] = trimmedFields;
        }
    }
    return payload;
}
async function $1ce9cf3f9c71f474$export$51b606e6d67c2231(interactionId, interaction) {
    const ufoNameOverride = $1ce9cf3f9c71f474$var$getUfoNameOverride(interaction);
    const modifiedInteraction = {
        ...interaction,
        ufoName: ufoNameOverride
    };
    const payloads = [];
    const isCriticalMetricsEnabled = (0, $dh538.fg)('platform_ufo_critical_metrics_payload');
    // Calculate VC metrics once to avoid duplicate expensive calculations
    const vcMetrics = await (0, $gffgQ.default)(interaction);
    // typeof Promise<CriticalMetricsPayload[]>
    const criticalMetricsPayloads = isCriticalMetricsEnabled ? await (0, $68a44b660af02473$export$dbc5b5c3cadc26f7)(interactionId, interaction, vcMetrics) : [];
    payloads.push(...criticalMetricsPayloads);
    const criticalPayloadCount = isCriticalMetricsEnabled ? criticalMetricsPayloads.length : undefined;
    const interactionMetricsPayload = await $1ce9cf3f9c71f474$var$createInteractionMetricsPayload(modifiedInteraction, interactionId, undefined, criticalPayloadCount, vcMetrics);
    payloads.push(interactionMetricsPayload);
    return payloads.filter(Boolean);
}
async function $1ce9cf3f9c71f474$export$6410c9ddb2ab201(interactionId, interaction) {
    const config = (0, $53d5Q.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const ufoName = (0, $3AFGg.sanitizeUfoName)(interaction.ufoName);
    const rate = (0, $53d5Q.getExperimentalInteractionRate)(ufoName, interaction.type);
    if (!(0, $1haRI.default)(rate)) return null;
    const pageVisibilityState = (0, $jJ2Ec.getPageVisibilityState)(interaction.start, interaction.end);
    if (pageVisibilityState !== 'visible') return null;
    const result = await $1ce9cf3f9c71f474$var$createInteractionMetricsPayload(interaction, interactionId, true);
    return result;
}
async function $1ce9cf3f9c71f474$export$84796f657a45566d(interactionId, interaction) {
    const SAIN_HOLD_NAMES = [
        'search-ai-dialog-visible-text-loading',
        'search-ai-dialog-all-text-loading'
    ];
    const NAME_OVERRIDE = 'search-page-ignoring-smart-answers';
    const SEARCH_PAGE_SMART_ANSWERS_SEGMENT_LABEL = 'search-page-smart-answers';
    const newInteractionId = `${interactionId}-ignoring-smart-answers`;
    // Calculate a new end time which excludes SAIN holds
    let newEnd;
    const { holdInfo: holdInfo, reactProfilerTimings: reactProfilerTimings } = interaction;
    const lastHold = holdInfo.at(-1);
    const isLastHoldSAIN = Boolean(lastHold && SAIN_HOLD_NAMES.includes(lastHold.name));
    // A new end time is only calculated if the last hold is a SAIN hold
    if (isLastHoldSAIN) {
        let lastFilteredTime = null;
        const filteredReactProfilerTimings = reactProfilerTimings.filter((timing)=>{
            if (timing.commitTime === lastFilteredTime) return false;
            const isTimingSmartAnswersInSearch = timing.labelStack.some((label)=>label.name === SEARCH_PAGE_SMART_ANSWERS_SEGMENT_LABEL);
            if (isTimingSmartAnswersInSearch) {
                lastFilteredTime = timing.commitTime;
                return false;
            }
            return true;
        });
        const lastTiming = filteredReactProfilerTimings.at(-1);
        if (lastTiming) newEnd = lastTiming.commitTime;
    }
    const modifiedInteraction = {
        ...interaction,
        end: newEnd ?? interaction.end,
        holdInfo: [],
        knownSegments: [],
        reactProfilerTimings: [],
        ufoName: NAME_OVERRIDE
    };
    const payloads = [];
    const vcMetrics = await (0, $gffgQ.default)(interaction, false, true);
    const interactionMetricsPayload = await $1ce9cf3f9c71f474$var$createInteractionMetricsPayload(modifiedInteraction, newInteractionId, undefined, undefined, vcMetrics);
    payloads.push(interactionMetricsPayload);
    return payloads.filter(Boolean);
}
module.exports["createPayloads"] = $1ce9cf3f9c71f474$export$51b606e6d67c2231;
module.exports["createExperimentalMetricsPayload"] = $1ce9cf3f9c71f474$export$6410c9ddb2ab201;
module.exports["createExtraSearchPageInteractionPayload"] = $1ce9cf3f9c71f474$export$84796f657a45566d;

});

parcelRegister("gY4WW", function(module, exports) {
function $1435165d93993c3e$var$getInteractionStatus(interaction) {
    let originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    const hasErrors = interaction.errors.length > 0;
    originalInteractionStatus = hasErrors ? 'FAILED' : originalInteractionStatus;
    // `overrideStatus` is to be deprecated - https://product-fabric.atlassian.net/browse/AFO-3760
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: originalInteractionStatus
    };
}
var $1435165d93993c3e$export$2e2bcd8739ae039 = $1435165d93993c3e$var$getInteractionStatus;
module.exports["default"] = $1435165d93993c3e$export$2e2bcd8739ae039;

});

parcelRegister("3uEtK", function(module, exports) {

var $jJ2Ec = parcelRequire("jJ2Ec");

function $bde92bd61e8ffee2$var$getPageVisibilityUpToTTAI(interaction) {
    const { start: start, end: end } = interaction;
    return (0, $jJ2Ec.getPageVisibilityState)(start, end);
}
var $bde92bd61e8ffee2$export$2e2bcd8739ae039 = $bde92bd61e8ffee2$var$getPageVisibilityUpToTTAI;
module.exports["default"] = $bde92bd61e8ffee2$export$2e2bcd8739ae039;

});

parcelRegister("lD0oL", function(module, exports) {
$parcel$export(module.exports, "default", () => $fead57a0258ca0a5$export$2e2bcd8739ae039);

var $3uEtK = parcelRequire("3uEtK");

function $fead57a0258ca0a5$export$2e2bcd8739ae039(interaction) {
    const { start: start, end: end } = interaction;
    const pageVisibilityUpToTTAI = (0, $3uEtK.default)(interaction);
    return !interaction.abortReason && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
}

});

parcelRegister("gffgQ", function(module, exports) {

var $1haRI = parcelRequire("1haRI");


var $53d5Q = parcelRequire("53d5Q");


var $4u5NT = parcelRequire("4u5NT");


var $gY4WW = parcelRequire("gY4WW");


var $3uEtK = parcelRequire("3uEtK");


var $657nk = parcelRequire("657nk");

async function $c32879a3fa820297$var$getVCMetrics(interaction, include3p = false, excludeSmartAnswersInSearch = false) {
    const config = (0, $53d5Q.getConfig)();
    if (!config?.vc?.enabled) return {};
    if (interaction.type !== 'page_load' && interaction.type !== 'transition' && interaction.type !== 'press') return {};
    const interactionStatus = (0, $gY4WW.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $3uEtK.default)(interaction);
    const isPageVisible = pageVisibilityUpToTTAI === 'visible';
    const shouldReportVCMetrics = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && isPageVisible;
    // Use per-interaction VC observer if available, otherwise fall back to global
    const observer = interaction.vcObserver;
    if (!observer) return {};
    const includeRawData = (0, $1haRI.default)((0, $53d5Q.getVCRawDataInteractionRate)(interaction.ufoName, interaction.type));
    const isSSREnabled = interaction.type === 'page_load' && (config?.ssr || config?.vc.ssrWhitelist?.includes(interaction.ufoName));
    const ssr = interaction.type === 'page_load' && isSSREnabled ? {
        ssr: (0, $657nk.default)(config)
    } : null;
    (0, $4u5NT.postInteractionLog).setVCObserverSSRConfig(ssr);
    const tti = interaction.apdex?.[0]?.stopTime;
    const prefix = 'ufo';
    const result = await observer.getVCResult({
        start: interaction.start,
        stop: interaction.end,
        // Use end3p when available to capture raw data observations during 3p holds
        rawDataStopTime: interaction.end3p,
        tti: tti,
        prefix: prefix,
        includeSSRInV3: config.vc?.includeSSRInV3,
        vc: interaction.vc,
        isEventAborted: interactionStatus.originalInteractionStatus !== 'SUCCEEDED',
        experienceKey: interaction.ufoName,
        interactionId: interaction.id,
        includeSSRRatio: config.vc?.includeSSRRatio,
        ...ssr,
        include3p: include3p,
        excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
        interactionType: interaction.type,
        isPageVisible: isPageVisible,
        includeRawData: includeRawData
    });
    observer.stop(interaction.ufoName);
    if (!include3p) {
        // For Post Interaction, last interaction should be without 3p
        (0, $4u5NT.postInteractionLog).setLastInteractionFinishVCResult(result);
        (0, $4u5NT.interactionExtraMetrics).setLastInteractionFinishVCResult(result);
    }
    const mostRecentVCRevision = (0, $53d5Q.getMostRecentVCRevision)(interaction.ufoName);
    const mostRecentVCRevisionPayload = result?.['ufo:vc:rev']?.find(({ revision: revision })=>revision === mostRecentVCRevision);
    if (!shouldReportVCMetrics || !mostRecentVCRevisionPayload?.clean) return result;
    return {
        ...result,
        'metric:vc90': mostRecentVCRevisionPayload['metric:vc90']
    };
}
var $c32879a3fa820297$export$2e2bcd8739ae039 = $c32879a3fa820297$var$getVCMetrics;
module.exports["default"] = $c32879a3fa820297$export$2e2bcd8739ae039;

});

parcelRegister("657nk", function(module, exports) {

var $hPcrh = parcelRequire("hPcrh");

function $a8261301e1ba8a2a$var$getSSRDoneTimeValue(config) {
    return config?.ssr?.getSSRDoneTime ? config?.ssr?.getSSRDoneTime() : $hPcrh.getSSRDoneTime();
}
var $a8261301e1ba8a2a$export$2e2bcd8739ae039 = $a8261301e1ba8a2a$var$getSSRDoneTimeValue;
module.exports["default"] = $a8261301e1ba8a2a$export$2e2bcd8739ae039;

});

parcelRegister("2G1lj", function(module, exports) {

var $3uEtK = parcelRequire("3uEtK");


var $6cRSt = parcelRequire("6cRSt");

function $aa2c48cbfad44fbb$export$97ea55623bd7f1ae(interaction) {
    const old = (0, $3uEtK.default)(interaction);
    const buffered = (0, $6cRSt.getVisibilityStateFromPerformance)(interaction.end);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}
module.exports["getMoreAccuratePageVisibilityUpToTTAI"] = $aa2c48cbfad44fbb$export$97ea55623bd7f1ae;

});

parcelRegister("6cRSt", function(module, exports) {
function $4731c539677c42e7$export$bcaa23184870682a(stop) {
    try {
        const results = performance.getEntriesByType('visibility-state');
        if (!results || results.length === 0) return null;
        // @ts-ignore
        return results.reduce((acc = null, { name: name, startTime: startTime })=>{
            if (startTime > stop) return acc;
            if (acc === null && name === null) return null;
            if (acc === null) return name;
            if (acc !== name) return 'mixed';
            return acc;
        }, null);
    } catch  {
        return null;
    }
}
module.exports["getVisibilityStateFromPerformance"] = $4731c539677c42e7$export$bcaa23184870682a;

});

parcelRegister("2j9Nh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c4b472c260ea0ce$export$2e2bcd8739ae039);
// Reusable TextEncoder instance to avoid creating new instances
const $2c4b472c260ea0ce$var$textEncoder = new TextEncoder();
function $2c4b472c260ea0ce$export$2e2bcd8739ae039(payload) {
    // Early return for null/undefined to avoid unnecessary processing
    if (!payload) return 0;
    // Use the reusable encoder instance
    return Math.round($2c4b472c260ea0ce$var$textEncoder.encode(JSON.stringify(payload)).length / 1024);
}

});

parcelRegister("1wWrF", function(module, exports) {

var $3AFGg = parcelRequire("3AFGg");

function $2abbcc7c844cb6f6$export$efbacb487c03c9c8(apdex, reactUFOVersion) {
    return apdex.map(({ stopTime: stopTime, labelStack: labelStack, ...others })=>({
            ...others,
            stopTime: Math.round(stopTime),
            ...labelStack ? {
                labelStack: (0, $3AFGg.optimizeLabelStack)(labelStack, reactUFOVersion)
            } : {}
        }));
}
module.exports["optimizeApdex"] = $2abbcc7c844cb6f6$export$efbacb487c03c9c8;

});

parcelRegister("eGSg6", function(module, exports) {
function $273137eb822d9212$export$967dd9693261321d(customTimings, interactionStart) {
    return customTimings.reduce((result, item)=>{
        Object.keys(item.data).forEach((key)=>{
            if (item.data[key].startTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: key
                    }
                ],
                startTime: Math.round(item.data[key].startTime),
                endTime: Math.round(item.data[key].endTime)
            });
        });
        return result;
    }, []);
}
module.exports["optimizeCustomTimings"] = $273137eb822d9212$export$967dd9693261321d;

});

parcelRegister("g4VPN", function(module, exports) {

var $3AFGg = parcelRequire("3AFGg");

function $9539020607f9f8b6$export$b983e6c30f3a8c82(holdInfo, interactionStart, reactUFOVersion) {
    const holdInfoMap = holdInfo.reduce((result, hold)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, ignoreOnSubmit: ignoreOnSubmit } = hold;
        if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
            const label = (0, $3AFGg.stringifyLabelStackFully)([
                ...labelStack,
                {
                    name: name
                }
            ]);
            const startTime = Math.round(start);
            const endTime = Math.round(end);
            const timing = result.get(label) || {
                labelStack: (0, $3AFGg.optimizeLabelStack)([
                    ...labelStack,
                    {
                        name: name
                    }
                ], reactUFOVersion),
                startTime: startTime,
                endTime: endTime
            };
            if (startTime < timing.startTime) timing.startTime = startTime;
            if (endTime > timing.endTime) timing.endTime = endTime;
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...holdInfoMap.values()
    ];
}
module.exports["optimizeHoldInfo"] = $9539020607f9f8b6$export$b983e6c30f3a8c82;

});

parcelRegister("9uif7", function(module, exports) {

var $3AFGg = parcelRequire("3AFGg");

function $74cf7a9426febbcc$export$4f8106ecc7ec1c7f(marks, reactUFOVersion) {
    return marks.map(({ labelStack: labelStack, time: time, ...others })=>({
            ...others,
            labelStack: labelStack && (0, $3AFGg.optimizeLabelStack)(labelStack, reactUFOVersion),
            time: Math.round(time)
        }));
}
module.exports["optimizeMarks"] = $74cf7a9426febbcc$export$4f8106ecc7ec1c7f;

});

parcelRegister("42oBg", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $4u5NT = parcelRequire("4u5NT");


var $3AFGg = parcelRequire("3AFGg");

function $bf991875f8b945fc$export$70a658ddbf644d3a(reactProfilerTimings, interactionStart, reactUFOVersion) {
    const reactProfilerTimingsMap = reactProfilerTimings.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
        if (labelStack && startTime >= interactionStart) {
            const label = (0, $3AFGg.stringifyLabelStackFully)(labelStack);
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            const timing = result.get(label) || {
                labelStack: (0, $3AFGg.optimizeLabelStack)(labelStack, reactUFOVersion),
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 0,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = start;
            if (end > timing.endTime) timing.endTime = end;
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            if ((0, $4u5NT.segmentUnmountCache).has(label) && (0, $dh538.fg)('platform_ufo_segment_unmount_count')) {
                timing.unmountCount = (0, $4u5NT.segmentUnmountCache).get(label) || 0;
                (0, $4u5NT.segmentUnmountCache).delete(label);
            }
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...reactProfilerTimingsMap.values()
    ];
}
module.exports["optimizeReactProfilerTimings"] = $bf991875f8b945fc$export$70a658ddbf644d3a;

});

parcelRegister("kzLre", function(module, exports) {

var $3AFGg = parcelRequire("3AFGg");

function $0542f5492cbc074d$export$9b2c740f95fe352d(requestInfo, interactionStart, reactUFOVersion) {
    const updatedRequestInfo = requestInfo.reduce((result, reqInfo)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, networkStart: networkStart, networkComplete: networkComplete } = reqInfo;
        const startTime = networkStart ?? start;
        const endTime = networkComplete ?? end;
        if (labelStack && start >= interactionStart && endTime) result.push({
            labelStack: (0, $3AFGg.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(startTime),
            endTime: Math.round(endTime)
        });
        return result;
    }, []);
    return updatedRequestInfo;
}
module.exports["optimizeRequestInfo"] = $0542f5492cbc074d$export$9b2c740f95fe352d;

});

parcelRegister("15prs", function(module, exports) {

var $3AFGg = parcelRequire("3AFGg");

function $99ca7b9dbc47ee50$export$e69673407fa1f9ed(spans, interactionStart, reactUFOVersion) {
    const updatedSpans = spans.reduce((result, span)=>{
        const { labelStack: labelStack, type: type, name: name, start: start, end: end } = span;
        if (labelStack && start >= interactionStart) result.push({
            labelStack: (0, $3AFGg.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(start),
            endTime: Math.round(end),
            type: type
        });
        return result;
    }, []);
    return updatedSpans;
}
module.exports["optimizeSpans"] = $99ca7b9dbc47ee50$export$e69673407fa1f9ed;

});


//# sourceMappingURL=create-payload.65f3cec4.js.map
